import { render, staticRenderFns } from "./TerminiCondizioni.vue?vue&type=template&id=13ffd475&"
import script from "./TerminiCondizioni.vue?vue&type=script&lang=js&"
export * from "./TerminiCondizioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports